import React from 'react';

import { UnitTour } from '../../types/Unit/Unit';

import styles from './UnitTable.module.scss';

interface Column {
    key: string;
    getValue?: Function;
    render?: (value: string) => string | React.ReactNode;
    width?: number | string;
}

interface TableProps {
    columns: Column[];
    data: UnitTour[];
}

const UnitTable = ({ columns = [], data }: TableProps) => {
    return (
        <div className={styles.root} data-cy="unit-table">
            {!data.length ? (
                <div className={styles.message}>No units found</div>
            ) : null}
            <table className={styles.table}>
                <tbody>
                    {data.map((d, index) => (
                        <tr key={index}>
                            {columns.map((column) => {
                                const value = column.getValue
                                    ? column.getValue(d)
                                    : d[column.key as keyof UnitTour];

                                return (
                                    <td key={column.key} width={column.width}>
                                        {value && column.render
                                            ? column.render(value)
                                            : value}
                                    </td>
                                );
                            })}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default UnitTable;
